import React, { useEffect, useState } from 'react';
import {
  MessagingInspectionViewRequest,
  MessagingInspectionViewRequestDetails,
} from '../../../../../../../../types/rest/analyticsTypes';
import FullPageLoader from '../../../../../../../../components/loaders/FullPageLoader';
import { MessageType } from '../../../../../../../../types/rest/dslTypes';
import { useIsMount } from '../../../../../../../../hooks/useIsMountHook';
import MessagingInspectionDetail from './MessagingInspectionDetail';
import analyticsApi from '../../../../../../../../axios/ac/analyticsApi';
import { showToastNotification } from '../../../../../../../../store/ui/toasts/toastsActions';
import { ToastType } from '../../../../../../../../store/ui/toasts/toastsTypes';
import { useDispatch } from 'react-redux';

interface Props {
  messageRequest: MessagingInspectionViewRequest;
}

//TODO - to be removed
const example: MessagingInspectionViewRequestDetails = {
  requestBody: 'This is an example request body text.',
  responseBody: 'This is an example response body text.',
  messageRequestHeaders: [
    {
      key: 'Content-Type',
      value: 'application/json',
    },
    {
      key: 'Authorization',
      value: 'Bearer token',
    },
  ],
  messageResponseHeaders: [
    {
      key: 'Content-Type',
      value: 'application/json',
    },
  ],
  messageRequestProperties: [
    {
      key: 'property1',
      value: 'value1',
      type: 'string',
    },
  ],
  messageResponseProperties: [
    {
      key: 'property2',
      value: 'value2',
      type: 'string',
    },
  ],
  messageType: MessageType.TEXT_MESSAGE,
} as any;

const MessagingDetail = ({ messageRequest }: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [messageDetail, setMessageDetail] = useState<MessagingInspectionViewRequestDetails>();
  const isMount = useIsMount();
  const dispatch = useDispatch();

  const getMessageDetail = async () => {
    try {
      const response = (await analyticsApi.inspectionData.getInspectionData(messageRequest.id)).data;
      setMessageDetail(response.result);
    } catch (e) {
      dispatch(showToastNotification(ToastType.Danger, 'Error getting message detail'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isMount) {
      getMessageDetail();
    }
  }, []);

  return (
    <div className={'p-4'}>
      {isLoading && <FullPageLoader className={'mt-8 mb-8'} loadingText={'Loading message detail...'} />}
      {!isLoading && <MessagingInspectionDetail messageRequest={messageDetail} />}
    </div>
  );
};

export default MessagingDetail;
